import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { ParkSessionStatus } from "ipctg-inflow-types/InFlowEnums"

import api from "@/utilities/api"

import { matchesToRoutes } from "@/utilities/etc"
import { log } from "@/utilities/logging"

export const Route = createFileRoute("/qr/$qrLookupID/passes/$epoch/purchase")({
  beforeLoad: async ({ context, matches, params, location }) => {
    const sessionState = await api.park.sessionStatus.POST({})
    const isPassesPage = matches.some(
      (m) => m.routeId === "/qr/$qrLookupID/passes/$epoch/purchase/"
    )
    /**
     * Browsing inventory needs no account, buying one does. Session exits are
     * handled at the root, so this only ever sees unauthenticated entry.
     */
    if (!isPassesPage && !context.isAuthenticated) {
      log({
        level: "warn",
        flow: "passes:purchase",
        scope: "guard.auth",
        message: "User is unauthenticated, redirecting to /sign-in",
        meta: { sessionState, isAuthenticated: context.isAuthenticated },
      })

      // Use TanStack Router's location.href (path) instead of browser's location.href (full URL)
      throw redirect({
        to: "/auth/sign-in",
        search: {
          redirect: location.href,
          qrLookupID: params.qrLookupID,
          phone: undefined,
          plate: undefined,
          conversionFlow: "requiredFlexPurchase",
          email: undefined,
        },
      })
    }

    const shouldSkipSessionStatusCompleteCheck = matchesToRoutes({
      matches,
      paths: [
        "/qr/$qrLookupID/passes/$epoch/purchase/confirmation",
        "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete",
      ],
    })

    // If payment/redemption is complete, redirect appropriately
    if (
      sessionState.status === ParkSessionStatus.Complete &&
      !shouldSkipSessionStatusCompleteCheck
    ) {
      log({
        level: "warn",
        flow: "passes:purchase",
        scope: "guard.sessionState",
        message:
          "Session is already complete, redirecting to /payment-complete",
        meta: { sessionState },
      })

      throw redirect({
        to: "/qr/$qrLookupID/passes/$epoch/purchase/payment-complete",
        params,
      })
    }

    return { sessionState }
  },
  component: Outlet,
})
